'use client';

import React from 'react';
import { useGlobalClientContext } from '../../common/GlobalClientContext';
import kubernetes from '../../../../public/images/kubernetes-1.png';
import { convertNewLinesToBrs } from '@altus-ui/components_v2/utils/text';

export default function Product() {
  const {
    i18nHelper: { t },
  } = useGlobalClientContext();

  const feature1Desc = t('public.site.product.managed.kubernetes.feature1.desc', {});
  return (
    <>
      <div className="flex flex-[1] flex-col items-center gap-3xl mb-9xl">
        <div className="text-5xl leading-18xl text-gray-900 font-semibold whitespace-nowrap">
          {t('public.site.product.managed.kubernetes.feature1', {})}
        </div>
        <div className="text-xl font-regular leading-3xl text-gray-600 text-center w-[800px]">
          {convertNewLinesToBrs(feature1Desc)}
        </div>
      </div>
      <img src={kubernetes.src} alt="kubernetes" />
      <div className="flex flex-row mt-9xl">
        <div className="flex flex-row gap-9xl">
          <div className="flex flex-1 flex-col gap-2xs w-[324px]">
            <div className="text-xl font-semibold leanding-lg text-primary">
              {t('public.site.product.managed.kubernetes.feature2', {})}
            </div>
            <div className="text-md font-regular leading-lg text-secondary">
              {t('public.site.product.managed.kubernetes.feature2.desc', {})}
            </div>
          </div>
          <div className="flex flex-1 flex-col gap-2xs w-[324px]">
            <div className="text-xl font-semibold leanding-lg text-primary">
              {t('public.site.product.managed.kubernetes.feature3', {})}
            </div>
            <div className="text-md font-regular leading-lg text-secondary">
              {t('public.site.product.managed.kubernetes.feature3.desc', {})}
            </div>
          </div>
          <div className="flex flex-1 flex-col gap-2xs w-[324px]">
            <div className="text-xl font-semibold leanding-lg text-primary">
              {t('public.site.product.managed.kubernetes.feature4', {})}
            </div>
            <div className="text-md font-regular leading-lg text-secondary">
              {t('public.site.product.managed.kubernetes.feature4.desc', {})}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
